// components/onboardingflow/ConsentScreen.jsx
// NEW SCREEN 1 — Step 3 in the target flow
// Consent confirmation → Consent registry update → Consent active
//
// Props:
//   onAgree()   — called when user checks box and clicks "Agree & Continue"
//   onDecline() — called when user clicks "Decline"

import React, { useState } from "react";
import styles from "./Consentscreen.module.css";

const CONSENT_ITEMS = [
  {
    icon: "📋",
    text: "I have read and understand the health assessment information provided.",
  },
  {
    icon: "🔒",
    text: "I understand that my data will be kept confidential and secure.",
  },
  {
    icon: "❤️",
    text: "I consent to the use of my health data to personalise my care journey.",
  },
  {
    icon: "↩️",
    text: "I understand that I can withdraw my consent at any time without penalty.",
  },
];

const ConsentScreen = ({ onAgree, onDecline }) => {
  const [agreed, setAgreed] = useState(false);

  return (
    <div className={styles.wrapper}>
      {/* Shield icon */}
      <div className={styles.shieldWrap}>
        <div className={styles.shield}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
              fill="#fff"
            />
            <polyline
              points="9 12 11 14 15 10"
              stroke="var(--primary-color, #6C5CE7)"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
          </svg>
        </div>
      </div>

      <h2 className={`ava-heading-md ${styles.title}`}>Before You Begin</h2>
      <p className={`ava-text-body ${styles.intro}`}>
        Please read and agree to the following before starting your health
        assessment.
      </p>

      {/* Consent items */}
      <div className={styles.itemList}>
        {CONSENT_ITEMS.map((item, i) => (
          <div key={i} className={styles.item}>
            <span className={styles.itemIcon}>{item.icon}</span>
            <span className={`ava-text-body ${styles.itemText}`}>
              {item.text}
            </span>
          </div>
        ))}
      </div>

      {/* Checkbox */}
      <label className={styles.checkLabel}>
        <input
          type="checkbox"
          checked={agreed}
          onChange={() => setAgreed((p) => !p)}
          className={styles.checkbox}
        />
        <span className={`ava-text-body ${styles.checkText}`}>
          I agree to all the above terms and conditions.
        </span>
      </label>

      {/* Actions */}
      <div className={styles.actions}>
        <button
          className={`ava-text-body ${styles.declineBtn}`}
          onClick={onDecline}
          type="button"
        >
          Decline
        </button>
        <button
          className={`btn-primary ${styles.agreeBtn}`}
          disabled={!agreed}
          onClick={onAgree}
          type="button"
        >
          Agree &amp; Continue →
        </button>
      </div>

      <p className={`ava-text-caption ${styles.footerNote}`}>
        If you have any questions, please contact our support team.
      </p>
    </div>
  );
};

export default ConsentScreen;